export default __webpack_public_path__ + "static/media/Steelers.2b9e8f63.png";